import dayjs from "dayjs";
import axios from "./axios";

export const getInstances = async () => {
  try {
    const data = await axios.get("/api/v1/provision/instance");
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getInstanceStatus = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const createInstance = async (value) => {
  try {
    const data = await axios.put("/api/v1/provision/instance", value);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const startInstance = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/instance/${id}?op=start`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const stopInstance = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/instance/${id}?op=stop`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const dropInstance = async (id) => {
  try {
    const data = await axios.delete(`/api/v1/provision/instance/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const upgradeInstance = async (id, version) => {
  try {
    const resp = await axios.post(
      `/api/v1/provision/instance/${id}?op=upgrade`,
      version,
    );
    return resp;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getVersionList = async () => {
  const vList = await axios.get("/api/v1/provision/versions");
  return vList;
};

export const getUpgradeVersionList = async (version) => {
  const vList = await axios.get(`/api/v1/provision/version/${version}?op=get.upgrade.versions`);
  return vList;
};

export const jumpToInstance = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/jump/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getBuiltInUsers = async (id) => {
  const userList = await axios.get(
    `/api/v1/provision/instance/${id}?op=get.builtin.users`,
  );
  return userList;
};

export const updatePassword = async (id, type, user) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.password`,
      { type: type, user: user },
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getIPWhiteList = async (id) => {
  const list = await axios.get(
    `/api/v1/provision/instance/${id}?op=get.whitelist`,
  );
  return list;
};

export const updateIPWhiteList = async (id, whitelist) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.whitelist`,
      { whitelist: whitelist },
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceNodegroups = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.nodegroups`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceHadoop = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.hadoop`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceMysql = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.mysql`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceDruid = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.druid`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const enableInstanceDruid = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=enable.druid`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const disableInstanceDruid = async (id) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=disable.druid`
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceGitea = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.gitea`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const enableInstanceGitea = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=enable.gitea`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const disableInstanceGitea = async (id) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=disable.gitea`
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceNeo4j = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.neo4j`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const enableInstanceNeo4j = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=enable.neo4j`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const disableInstanceNeo4j = async (id) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=disable.neo4j`
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceVIA = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.via`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const updateInstanceDomain = async (id, { domain }) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.domain`,
      { domain },
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getInstanceNodegroup = async (id) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/instance/${id}?op=get.nodegroups`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceHadoop = async (id) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/instance/${id}?op=get.hadoop`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceMysql = async (id) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/instance/${id}?op=get.mysql`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceVIA = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}?op=get.via`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceDruid = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}?op=get.druid`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceGitea = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}?op=get.gitea`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const getInstanceNeo4j = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}?op=get.neo4j`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
export const validateInstanceDomain = async (id, domain) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=validate.domain`,
      { domain },
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getTopology = async (id) => {
  const topology = await axios.get(`/api/v1/provision/topology/${id}`);
  return topology;
};

export const getSecurity = async (id) => {
  try {
    const security = await axios.get(`/api/v1/provision/security/${id}`);
    return security;
  } catch (error) {
    return { status: "error", error };
  }
};

export const fetchPassword = async (id, type, name) => {
  try {
    const password = await axios.get(
      `/api/v1/provision/security/${id}?op=fetch.password&type=${type}&username=${name}`,
    );
    return password;
  } catch (error) {
    console.error("fetchPassword failed:", error);
    return { status: "error", error };
  }
};

export const getData = async (id) => {
  try {
    const data = await axios.get(`/api/v1/provision/data/${id}`);
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getDataDetail = async (id, type, path) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/data/${id}?op=list&type=${type}&path=${path}`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const retryCreateInstance = async (id) => {
  try {
    const data = await axios.post(`/api/v1/provision/instance/${id}?op=retry`);
    return data;
  } catch (error) {
    return { status: "error", error: error?.message };
  }
};

export const getTokens = async (id) => {
  try {
    const tokenArr = await axios.get(
      `/api/v1/provision/instance/${id}?op=get.all.tokens`,
    );
    const tokenList = tokenArr.flatMap(item => {  
      // 对内层数组B进行遍历，并映射出包含字段A、c和d的新对象数组  
      return item.tokens.map(token => ({  
        user: item.user,  
        label: token.label,  
        expiredTime: token.expiredTime ? dayjs(token.expiredTime, 'YYYYMMDDTHH:mm:ssZ').format('YYYY-MM-DD HH:mm:ss') : '',
        created: dayjs(token.created, 'YYYYMMDDTHH:mm:ssZ').format('YYYY-MM-DD HH:mm:ss'),
        lastUsed: dayjs(token.lastUsed, 'YYYYMMDDTHH:mm:ssZ').format('YYYY-MM-DD HH:mm:ss'),
        token: token.token
      }));  
    });  
    return tokenList;
  } catch (error) {
    return { status: "error", error };
  }
};

export const addTokens = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=add.token`,
      value
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const udpateTokens = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.token`,
      value
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const revokeTokens = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=revoke.token`,
      value
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getTenantUsers = async (id) => {
  const list = await axios.get(
    `/api/v1/provision/instance/${id}?op=get.tenant.users`,
  );
  return list;
};

export const addTenantUsers = async (id, value) => {
  const data = await axios.post(
    `/api/v1/provision/instance/${id}?op=add.tenant.users`,
    value
  );
  return data;
};

export const removeTenantUsers = async (id, value) => {
  const data = await axios.post(
    `/api/v1/provision/instance/${id}?op=remove.tenant.users`,
    value
  );
  return data;
};

export const getInstanceMaintenanceHistory = async(id, params) => {
  try {
    const data = await axios.get(`/api/v1/provision/instance/${id}?op=get.maintenance.history`, {params:params});
    return data;
  } catch (error) {
    return { status: "error", error };
  }
}

export const getInstanceMaintenance = async (id) => {
  const maintenance = await axios.get(
    `/api/v1/provision/instance/${id}?op=get.maintenance`,
  );
  return maintenance;
};

export const updateInstanceMaintenance = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=update.maintenance`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const enableInstanceMaintenance = async (id, value) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=enable.maintenance`,
      value,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const disableInstanceMaintenance = async (id) => {
  try {
    const data = await axios.post(
      `/api/v1/provision/instance/${id}?op=disable.maintenance`
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};